<section class="error-page-title"></section>
<div class="error-page-content">
  <h1>
    {{ 'pageNotFound.message1' | translate }}
  </h1>
  <div class="error-page-text">
    <p>{{ 'pageNotFound.message2' | translate }}</p>
  </div>

  <div class="buttons__wrapper">
    <span>
      <button
        type="button"
        class="btn btn-primary btn-lg"
        (click)="goHome()"
        tabindex="6"
      >
        {{ 'pageNotFound.goHome' | translate }}
      </button>
    </span>
  </div>
</div>
